import { useContext } from "react";
import { HttpMethods } from "../../enums/HttpMethods";
import { NotificationTypes } from "../../enums/NotificationTypes";
import VspPortalContext from "../../store/VspPortalContext";
import { IotDeviceEventDto } from "./dtos/IotDeviceEventDto";
import { IotDeviceEventLatestDto } from "./dtos/IotDeviceEventLatestDto";
import { IotDeviceEventSummaryDto } from "./dtos/IotDeviceEventSummaryDto";
import { VspPortalActions } from "../../store/VspPortalActions";
import { useVspPortalHttp } from "../../hooks/useVspPortalHttp";



export const useIotDeviceEvents = (): {

    getIotDeviceEvents( deviceEuid: string, gatewayNetworkMac: string, villageCode: string ): Promise<IotDeviceEventDto[] | null>
    , getIotDeviceEventsLatest( villageCode: string, statuses: string[ ] ): Promise<IotDeviceEventLatestDto[] | null>
    , getIotDeviceEventsSummary( villageCode: string ): Promise<IotDeviceEventSummaryDto[] | null>

} => {

    const { fetchData, getHttpOptions } = useVspPortalHttp( );
    const { dispatch, state } = useContext( VspPortalContext );


    const getIotDeviceEvents = async( deviceEuid: string, gatewayNetworkMac: string, villageCode: string ): Promise<IotDeviceEventDto[] | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/iotdevice/event?villageCode=${villageCode}&gatewayNetworkMac=${gatewayNetworkMac}&deviceEuid=${deviceEuid}`;

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching IoT device events' });

            return null;

        }

        return await response.response?.json( );

    };

    
    const getIotDeviceEventsLatest = async( villageCode: string, statuses: string[ ] ): Promise<IotDeviceEventLatestDto[] | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/iotdevice/event/Latest?villageCode=${villageCode}&statuses=` + statuses.join( '&statuses=' );
        
        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching latest IoT device statuses' });

            return null;

        }

        return await response.response?.json( );        
        
    };
    

    const getIotDeviceEventsSummary = async( villageCode: string ): Promise<IotDeviceEventSummaryDto[] | null> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/iotdevice/event/summary?villageCode=${villageCode}`;
        
        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error fetching IoT Device events summary' });

            return null;

        }

        if ( response.statusCode === 200 ) {
        
            return await response.response?.json( );

        }

        return [ ];
        
    };


    return {

        getIotDeviceEvents
        , getIotDeviceEventsLatest
        , getIotDeviceEventsSummary

    };

};
